module.exports = __webpack_public_path__ + "img/screen-manual-11.56144ddd.png";